import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import NavBar from 'js/components/NavBar';
import Footer from 'cccisd-footer';
import style from './style.css';
export default class FluidLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
    };

    render() {
        return (
            <div>
                <NavBar className="container-fluid" />
                <div className="container-fluid">{this.props.children}</div>
                <div className={style.footer}>
                    <Footer className="container-fluid" />
                </div>
            </div>
        );
    }
}
